class y extends Error {
  response;
  request;
  options;
  constructor(e, t, r) {
    const o = e.status || e.status === 0 ? e.status : "", a = e.statusText || "", n = `${o} ${a}`.trim(), i = n ? `status code ${n}` : "an unknown error";
    super(`Request failed with ${i}: ${t.method} ${t.url}`), this.name = "HTTPError", this.response = e, this.request = t, this.options = r;
  }
}
class v extends Error {
  request;
  constructor(e) {
    super(`Request timed out: ${e.method} ${e.url}`), this.name = "TimeoutError", this.request = e;
  }
}
const f = (s) => s !== null && typeof s == "object", d = (...s) => {
  for (const e of s)
    if ((!f(e) || Array.isArray(e)) && e !== void 0)
      throw new TypeError("The `options` argument must be an object");
  return b({}, ...s);
}, F = (s = {}, e = {}) => {
  const t = new globalThis.Headers(s), r = e instanceof globalThis.Headers, o = new globalThis.Headers(e);
  for (const [a, n] of o.entries())
    r && n === "undefined" || n === void 0 ? t.delete(a) : t.set(a, n);
  return t;
};
function l(s, e, t) {
  return Object.hasOwn(e, t) && e[t] === void 0 ? [] : b(s[t] ?? [], e[t] ?? []);
}
const N = (s = {}, e = {}) => ({
  beforeRequest: l(s, e, "beforeRequest"),
  beforeRetry: l(s, e, "beforeRetry"),
  afterResponse: l(s, e, "afterResponse"),
  beforeError: l(s, e, "beforeError")
}), b = (...s) => {
  let e = {}, t = {}, r = {};
  for (const o of s)
    if (Array.isArray(o))
      Array.isArray(e) || (e = []), e = [...e, ...o];
    else if (f(o)) {
      for (let [a, n] of Object.entries(o))
        f(n) && a in e && (n = b(e[a], n)), e = { ...e, [a]: n };
      f(o.hooks) && (r = N(r, o.hooks), e.hooks = r), f(o.headers) && (t = F(t, o.headers), e.headers = t);
    }
  return e;
}, U = (() => {
  let s = !1, e = !1;
  const t = typeof globalThis.ReadableStream == "function", r = typeof globalThis.Request == "function";
  if (t && r)
    try {
      e = new globalThis.Request("https://empty.invalid", {
        body: new globalThis.ReadableStream(),
        method: "POST",
        // @ts-expect-error - Types are outdated.
        get duplex() {
          return s = !0, "half";
        }
      }).headers.has("Content-Type");
    } catch (o) {
      if (o instanceof Error && o.message === "unsupported BodyInit type")
        return !1;
      throw o;
    }
  return s && !e;
})(), O = typeof globalThis.AbortController == "function", P = typeof globalThis.ReadableStream == "function", M = typeof globalThis.FormData == "function", A = ["get", "post", "put", "patch", "head", "delete"], H = {
  json: "application/json",
  text: "text/*",
  formData: "multipart/form-data",
  arrayBuffer: "*/*",
  blob: "*/*"
}, m = 2147483647, I = Symbol("stop"), L = {
  json: !0,
  parseJson: !0,
  stringifyJson: !0,
  searchParams: !0,
  prefixUrl: !0,
  retry: !0,
  timeout: !0,
  hooks: !0,
  throwHttpErrors: !0,
  onDownloadProgress: !0,
  fetch: !0
}, z = {
  method: !0,
  headers: !0,
  body: !0,
  mode: !0,
  credentials: !0,
  cache: !0,
  redirect: !0,
  referrer: !0,
  referrerPolicy: !0,
  integrity: !0,
  keepalive: !0,
  signal: !0,
  window: !0,
  dispatcher: !0,
  duplex: !0,
  priority: !0
}, j = (s) => A.includes(s) ? s.toUpperCase() : s, J = ["get", "put", "head", "delete", "options", "trace"], D = [408, 413, 429, 500, 502, 503, 504], B = [413, 429, 503], q = {
  limit: 2,
  methods: J,
  statusCodes: D,
  afterStatusCodes: B,
  maxRetryAfter: Number.POSITIVE_INFINITY,
  backoffLimit: Number.POSITIVE_INFINITY,
  delay: (s) => 0.3 * 2 ** (s - 1) * 1e3
}, $ = (s = {}) => {
  if (typeof s == "number")
    return {
      ...q,
      limit: s
    };
  if (s.methods && !Array.isArray(s.methods))
    throw new Error("retry.methods must be an array");
  if (s.statusCodes && !Array.isArray(s.statusCodes))
    throw new Error("retry.statusCodes must be an array");
  return {
    ...q,
    ...s
  };
};
async function V(s, e, t, r) {
  return new Promise((o, a) => {
    const n = setTimeout(() => {
      t && t.abort(), a(new v(s));
    }, r.timeout);
    r.fetch(s, e).then(o).catch(a).then(() => {
      clearTimeout(n);
    });
  });
}
async function Y(s, { signal: e }) {
  return new Promise((t, r) => {
    e && (e.throwIfAborted(), e.addEventListener("abort", o, { once: !0 }));
    function o() {
      clearTimeout(a), r(e.reason);
    }
    const a = setTimeout(() => {
      e?.removeEventListener("abort", o), t();
    }, s);
  });
}
const Q = (s, e) => {
  const t = {};
  for (const r in e)
    !(r in z) && !(r in L) && !(r in s) && (t[r] = e[r]);
  return t;
};
class p {
  static create(e, t) {
    const r = new p(e, t), o = async () => {
      if (typeof r._options.timeout == "number" && r._options.timeout > m)
        throw new RangeError(`The \`timeout\` option cannot be greater than ${m}`);
      await Promise.resolve();
      let i = await r._fetch();
      for (const c of r._options.hooks.afterResponse) {
        const h = await c(r.request, r._options, r._decorateResponse(i.clone()));
        h instanceof globalThis.Response && (i = h);
      }
      if (r._decorateResponse(i), !i.ok && r._options.throwHttpErrors) {
        let c = new y(i, r.request, r._options);
        for (const h of r._options.hooks.beforeError)
          c = await h(c);
        throw c;
      }
      if (r._options.onDownloadProgress) {
        if (typeof r._options.onDownloadProgress != "function")
          throw new TypeError("The `onDownloadProgress` option must be a function");
        if (!P)
          throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
        return r._stream(i.clone(), r._options.onDownloadProgress);
      }
      return i;
    }, n = r._options.retry.methods.includes(r.request.method.toLowerCase()) ? r._retry(o) : o();
    for (const [i, c] of Object.entries(H))
      n[i] = async () => {
        r.request.headers.set("accept", r.request.headers.get("accept") || c);
        const h = await n;
        if (i === "json") {
          if (h.status === 204 || (await h.clone().arrayBuffer()).byteLength === 0)
            return "";
          if (t.parseJson)
            return t.parseJson(await h.text());
        }
        return h[i]();
      };
    return n;
  }
  request;
  abortController;
  _retryCount = 0;
  _input;
  _options;
  // eslint-disable-next-line complexity
  constructor(e, t = {}) {
    if (this._input = e, this._options = {
      ...t,
      headers: F(this._input.headers, t.headers),
      hooks: N({
        beforeRequest: [],
        beforeRetry: [],
        beforeError: [],
        afterResponse: []
      }, t.hooks),
      method: j(t.method ?? this._input.method ?? "GET"),
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      prefixUrl: String(t.prefixUrl || ""),
      retry: $(t.retry),
      throwHttpErrors: t.throwHttpErrors !== !1,
      timeout: t.timeout ?? 1e4,
      fetch: t.fetch ?? globalThis.fetch.bind(globalThis)
    }, typeof this._input != "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request))
      throw new TypeError("`input` must be a string, URL, or Request");
    if (this._options.prefixUrl && typeof this._input == "string") {
      if (this._input.startsWith("/"))
        throw new Error("`input` must not begin with a slash when using `prefixUrl`");
      this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
    }
    if (O) {
      this.abortController = new globalThis.AbortController();
      const r = this._options.signal ?? this._input.signal;
      r?.aborted && this.abortController.abort(r?.reason), r?.addEventListener("abort", () => {
        this.abortController.abort(r.reason);
      }), this._options.signal = this.abortController.signal;
    }
    if (U && (this._options.duplex = "half"), this._options.json !== void 0 && (this._options.body = this._options.stringifyJson?.(this._options.json) ?? JSON.stringify(this._options.json), this._options.headers.set("content-type", this._options.headers.get("content-type") ?? "application/json")), this.request = new globalThis.Request(this._input, this._options), this._options.searchParams) {
      const o = "?" + (typeof this._options.searchParams == "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString()), a = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, o);
      (M && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"]) && this.request.headers.delete("content-type"), this.request = new globalThis.Request(new globalThis.Request(a, { ...this.request }), this._options);
    }
  }
  _calculateRetryDelay(e) {
    if (this._retryCount++, this._retryCount > this._options.retry.limit || e instanceof v)
      throw e;
    if (e instanceof y) {
      if (!this._options.retry.statusCodes.includes(e.response.status))
        throw e;
      const r = e.response.headers.get("Retry-After") ?? e.response.headers.get("RateLimit-Reset") ?? e.response.headers.get("X-RateLimit-Reset") ?? e.response.headers.get("X-Rate-Limit-Reset");
      if (r && this._options.retry.afterStatusCodes.includes(e.response.status)) {
        let o = Number(r) * 1e3;
        Number.isNaN(o) ? o = Date.parse(r) - Date.now() : o >= Date.parse("2024-01-01") && (o -= Date.now());
        const a = this._options.retry.maxRetryAfter ?? o;
        return o < a ? o : a;
      }
      if (e.response.status === 413)
        throw e;
    }
    const t = this._options.retry.delay(this._retryCount);
    return Math.min(this._options.retry.backoffLimit, t);
  }
  _decorateResponse(e) {
    return this._options.parseJson && (e.json = async () => this._options.parseJson(await e.text())), e;
  }
  async _retry(e) {
    try {
      return await e();
    } catch (t) {
      const r = Math.min(this._calculateRetryDelay(t), m);
      if (this._retryCount < 1)
        throw t;
      await Y(r, { signal: this._options.signal });
      for (const o of this._options.hooks.beforeRetry)
        if (await o({
          request: this.request,
          options: this._options,
          error: t,
          retryCount: this._retryCount
        }) === I)
          return;
      return this._retry(e);
    }
  }
  async _fetch() {
    for (const r of this._options.hooks.beforeRequest) {
      const o = await r(this.request, this._options);
      if (o instanceof Request) {
        this.request = o;
        break;
      }
      if (o instanceof Response)
        return o;
    }
    const e = Q(this.request, this._options), t = this.request;
    return this.request = t.clone(), this._options.timeout === !1 ? this._options.fetch(t, e) : V(t, e, this.abortController, this._options);
  }
  /* istanbul ignore next */
  _stream(e, t) {
    const r = Number(e.headers.get("content-length")) || 0;
    let o = 0;
    return e.status === 204 ? (t && t({ percent: 1, totalBytes: r, transferredBytes: o }, new Uint8Array()), new globalThis.Response(null, {
      status: e.status,
      statusText: e.statusText,
      headers: e.headers
    })) : new globalThis.Response(new globalThis.ReadableStream({
      async start(a) {
        const n = e.body.getReader();
        t && t({ percent: 0, transferredBytes: 0, totalBytes: r }, new Uint8Array());
        async function i() {
          const { done: c, value: h } = await n.read();
          if (c) {
            a.close();
            return;
          }
          if (t) {
            o += h.byteLength;
            const u = r === 0 ? 0 : o / r;
            t({ percent: u, transferredBytes: o, totalBytes: r }, h);
          }
          a.enqueue(h), await i();
        }
        await i();
      }
    }), {
      status: e.status,
      statusText: e.statusText,
      headers: e.headers
    });
  }
}
/*! MIT License © Sindre Sorhus */
const g = (s) => {
  const e = (t, r) => p.create(t, d(s, r));
  for (const t of A)
    e[t] = (r, o) => p.create(r, d(s, o, { method: t }));
  return e.create = (t) => g(d(t)), e.extend = (t) => (typeof t == "function" && (t = t(s ?? {})), g(d(s, t))), e.stop = I, e;
}, G = g();
class W extends Map {
  #r = 0;
  #e = /* @__PURE__ */ new Map();
  #t = /* @__PURE__ */ new Map();
  #o;
  #i;
  #n;
  constructor(e = {}) {
    if (super(), !(e.maxSize && e.maxSize > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    if (typeof e.maxAge == "number" && e.maxAge === 0)
      throw new TypeError("`maxAge` must be a number greater than 0");
    this.#o = e.maxSize, this.#i = e.maxAge || Number.POSITIVE_INFINITY, this.#n = e.onEviction;
  }
  // For tests.
  get __oldCache() {
    return this.#t;
  }
  #a(e) {
    if (typeof this.#n == "function")
      for (const [t, r] of e)
        this.#n(t, r.value);
  }
  #s(e, t) {
    return typeof t.expiry == "number" && t.expiry <= Date.now() ? (typeof this.#n == "function" && this.#n(e, t.value), this.delete(e)) : !1;
  }
  #d(e, t) {
    if (this.#s(e, t) === !1)
      return t.value;
  }
  #h(e, t) {
    return t.expiry ? this.#d(e, t) : t.value;
  }
  #c(e, t) {
    const r = t.get(e);
    return this.#h(e, r);
  }
  #u(e, t) {
    this.#e.set(e, t), this.#r++, this.#r >= this.#o && (this.#r = 0, this.#a(this.#t), this.#t = this.#e, this.#e = /* @__PURE__ */ new Map());
  }
  #l(e, t) {
    this.#t.delete(e), this.#u(e, t);
  }
  *#f() {
    for (const e of this.#t) {
      const [t, r] = e;
      this.#e.has(t) || this.#s(t, r) === !1 && (yield e);
    }
    for (const e of this.#e) {
      const [t, r] = e;
      this.#s(t, r) === !1 && (yield e);
    }
  }
  get(e) {
    if (this.#e.has(e)) {
      const t = this.#e.get(e);
      return this.#h(e, t);
    }
    if (this.#t.has(e)) {
      const t = this.#t.get(e);
      if (this.#s(e, t) === !1)
        return this.#l(e, t), t.value;
    }
  }
  set(e, t, { maxAge: r = this.#i } = {}) {
    const o = typeof r == "number" && r !== Number.POSITIVE_INFINITY ? Date.now() + r : void 0;
    return this.#e.has(e) ? this.#e.set(e, {
      value: t,
      expiry: o
    }) : this.#u(e, { value: t, expiry: o }), this;
  }
  has(e) {
    return this.#e.has(e) ? !this.#s(e, this.#e.get(e)) : this.#t.has(e) ? !this.#s(e, this.#t.get(e)) : !1;
  }
  peek(e) {
    if (this.#e.has(e))
      return this.#c(e, this.#e);
    if (this.#t.has(e))
      return this.#c(e, this.#t);
  }
  expiresIn(e) {
    const t = this.#e.get(e) ?? this.#t.get(e);
    if (t)
      return t.expiry ? t.expiry - Date.now() : Number.POSITIVE_INFINITY;
  }
  delete(e) {
    const t = this.#e.delete(e);
    return t && this.#r--, this.#t.delete(e) || t;
  }
  clear() {
    this.#e.clear(), this.#t.clear(), this.#r = 0;
  }
  resize(e) {
    if (!(e && e > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    const t = [...this.#f()], r = t.length - e;
    r < 0 ? (this.#e = new Map(t), this.#t = /* @__PURE__ */ new Map(), this.#r = t.length) : (r > 0 && this.#a(t.slice(0, r)), this.#t = new Map(t.slice(r)), this.#e = /* @__PURE__ */ new Map(), this.#r = 0), this.#o = e;
  }
  *keys() {
    for (const [e] of this)
      yield e;
  }
  *values() {
    for (const [, e] of this)
      yield e;
  }
  *[Symbol.iterator]() {
    for (const e of this.#e) {
      const [t, r] = e;
      this.#s(t, r) === !1 && (yield [t, r.value]);
    }
    for (const e of this.#t) {
      const [t, r] = e;
      this.#e.has(t) || this.#s(t, r) === !1 && (yield [t, r.value]);
    }
  }
  *entriesDescending() {
    let e = [...this.#e];
    for (let t = e.length - 1; t >= 0; --t) {
      const r = e[t], [o, a] = r;
      this.#s(o, a) === !1 && (yield [o, a.value]);
    }
    e = [...this.#t];
    for (let t = e.length - 1; t >= 0; --t) {
      const r = e[t], [o, a] = r;
      this.#e.has(o) || this.#s(o, a) === !1 && (yield [o, a.value]);
    }
  }
  *entriesAscending() {
    for (const [e, t] of this.#f())
      yield [e, t.value];
  }
  get size() {
    if (!this.#r)
      return this.#t.size;
    let e = 0;
    for (const t of this.#t.keys())
      this.#e.has(t) || e++;
    return Math.min(this.#r + e, this.#o);
  }
  get maxSize() {
    return this.#o;
  }
  entries() {
    return this.entriesAscending();
  }
  forEach(e, t = this) {
    for (const [r, o] of this.entriesAscending())
      e.call(t, o, r, this);
  }
  get [Symbol.toStringTag]() {
    return "QuickLRU";
  }
  toString() {
    return `QuickLRU(${this.size}/${this.maxSize})`;
  }
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.toString();
  }
}
const X = 1e3 * 60 * 5, K = new W({
  maxSize: 500,
  maxAge: X
}), Z = (s) => (e) => {
  s && e.headers.set("Authorization", s);
}, ee = (s) => (e) => {
  e.headers.has("Content-Type") || e.headers.set("Content-Type", "application/json"), s && e.headers.set("accept-language", s);
}, te = (s = 0) => (e, t, r) => (e.method === "GET" && r.ok && s > 0 && K.set(r.url, r.clone(), { maxAge: s }), r), se = (s) => {
  const e = [
    ee(s.acceptLanguage),
    Z(s.authToken)
  ];
  return s.onRequest && e.push(s.onRequest), e.length > 0 ? e : void 0;
}, re = (s) => {
  const e = [te(s.cacheTTL)];
  return s.onResponse && e.push(s.onResponse), e.length > 0 ? e : void 0;
}, oe = (s) => {
  const e = [];
  return s.onError && e.push(s.onError), e.length > 0 ? e : void 0;
}, ne = (s) => G.create({
  prefixUrl: s.apiUrl,
  timeout: s.timeout ?? !1,
  retry: s.retry ?? 1,
  credentials: s.credentials,
  headers: {
    accept: "application/json"
  },
  hooks: {
    beforeRequest: se(s),
    afterResponse: re(s),
    beforeError: oe(s)
  }
});
class w extends Error {
  context;
  status;
  cause;
  constructor(e, t) {
    const r = `Request failed with status code ${e.response.status}`;
    super(r), this.name = "FetcherHTTPError", this.message = r, this.context = e, this.status = e.response.status, this.cause = t, Error.captureStackTrace && Error.captureStackTrace(this, w);
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      context: this.context,
      status: this.status,
      cause: this.cause
    };
  }
}
function ue(s) {
  return s && s.name === "FetcherHTTPError";
}
async function ie(s) {
  return {
    response: {
      bodyUsed: s.response.bodyUsed,
      body: await s.response.text(),
      ok: s.response.ok,
      redirected: s.response.redirected,
      status: s.response.status,
      type: s.response.type,
      url: s.response.url
    },
    request: {
      bodyUsed: s.request.bodyUsed,
      cache: s.request.cache,
      method: s.request.mode,
      mode: s.request.mode,
      redirect: s.request.redirect,
      referrer: s.request.referrer,
      referrerPolicy: s.request.referrerPolicy,
      url: s.request.url
    }
  };
}
class E extends Error {
  cause;
  constructor(e) {
    const t = "An unknown error occurred";
    super(t), this.name = "FetcherUnknownError", this.message = typeof e == "string" ? e : t, e instanceof Error && (this.stack = e.stack, this.message = e.message), this.cause = e, Error.captureStackTrace && Error.captureStackTrace(this, E);
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      cause: this.cause
    };
  }
}
function fe(s) {
  return s && s.name === "FetcherUnknownError";
}
class T extends Error {
  context;
  code;
  status;
  cause;
  meta;
  constructor(e, t, r, o, a) {
    super(t), this.name = "FetcherBusinessRuleError", this.message = t, this.context = r, this.status = r.response.status, this.code = e, this.meta = a, this.cause = o, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, T);
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      context: this.context,
      status: this.status,
      code: this.code,
      meta: this.meta,
      cause: this.cause
    };
  }
}
function de(s) {
  return s && s.name === "FetcherBusinessRuleError";
}
class R extends Error {
  context;
  meta;
  status;
  cause;
  constructor(e, t, r) {
    const o = "Request failed due to data validation error";
    super(o), this.name = "FetcherFormValidationError", this.message = o, this.context = t, this.status = t.response.status, this.meta = e, this.cause = r, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, R);
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      context: this.context,
      status: this.status,
      meta: this.meta,
      cause: this.cause
    };
  }
}
function le(s) {
  return s && s.name === "FetcherFormValidationError";
}
class x extends Error {
  cause;
  constructor(e) {
    const t = "An unknown error occurred";
    super(t), this.name = "FetcherConnectionLostError", this.message = typeof e == "string" ? e : t, e instanceof Error && (this.stack = e.stack, this.message = e.message), this.cause = e, Error.captureStackTrace && Error.captureStackTrace(this, x);
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      cause: this.cause
    };
  }
}
function pe(s) {
  return s && s.name === "FetcherConnectionLostError";
}
class _ extends Error {
  context;
  cause;
  constructor(e, t) {
    const r = "404 Not Found";
    super(r), this.name = "FetcherNotFoundError", this.message = r, this.context = e, this.cause = t, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, _);
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      context: this.context,
      cause: this.cause
    };
  }
}
function me(s) {
  return s && s.name === "FetcherNotFoundError";
}
class S extends Error {
  context;
  cause;
  constructor(e, t) {
    const r = "401 Unauthorized";
    super(r), this.name = "FetcherUnauthorizedError", this.message = r, this.context = e, this.cause = t, Error.captureStackTrace && Error.captureStackTrace(this, S);
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      context: this.context,
      cause: this.cause
    };
  }
}
function ye(s) {
  return s && s.name === "FetcherUnauthorizedError";
}
class k extends Error {
  context;
  cause;
  constructor(e, t) {
    const r = "429 Too Many Requests";
    super(r), this.name = "FetcherTooManyRequestsError", this.message = r, this.context = e, this.cause = t, Error.captureStackTrace && Error.captureStackTrace(this, k);
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      context: this.context,
      cause: this.cause
    };
  }
}
function ge(s) {
  return s && s.name === "FetcherTooManyRequestsError";
}
const ae = (s) => s.message.toLowerCase().includes("failed to fetch") || s.message.toLowerCase().includes("networkerror") || s.message.toLowerCase().includes("failed to execute fetch");
async function C(s) {
  if (s instanceof TypeError && ae(s))
    return new x(s);
  if (!(s instanceof y))
    return new E(s);
  const e = s.response.status, t = await ie(s);
  if (e === 404)
    return new _(t, s);
  if (e === 429)
    return new k(t, s);
  if (e === 401)
    return new S(t, s);
  let r;
  try {
    r = JSON.parse(t.response.body);
  } catch {
    r = void 0;
  }
  const o = r?.errors;
  if (e === 422 && o)
    return new R(o, t, s);
  const a = r?.error;
  return e === 422 && a?.code ? new T(
    a.code,
    a.message ?? "Request failed due to a business rule",
    t,
    s,
    a.context ?? void 0
  ) : new w(t, s);
}
function he(s) {
  const e = new URLSearchParams();
  return s && Object.entries(s).forEach(([t, r]) => {
    Array.isArray(r) ? r.forEach((o) => e.append(`${t}[]`, o)) : r !== void 0 && e.append(t, r.toString());
  }), e.toString();
}
const be = (s) => {
  const e = ne(s), t = (n) => {
    const i = {};
    return n?.headers && (i.headers = n.headers), n?.params && (i.searchParams = he(n.params)), i;
  }, r = async (n, i, c) => {
    try {
      const u = await (await e(i, {
        method: n,
        ...t(c)
      })).text();
      return u ? JSON.parse(u) : {};
    } catch (h) {
      throw await C(h);
    }
  }, o = (n) => {
    const i = {};
    return n?.headers && (i.headers = n.headers), n?.params && (i.searchParams = n.params), n?.body && (i.json = n.body), n?.formData && (i.body = n.formData), i;
  }, a = async (n, i, c) => {
    try {
      const u = await (await e(i, {
        method: n,
        ...o(c)
      })).text();
      return u ? JSON.parse(u) : {};
    } catch (h) {
      throw await C(h);
    }
  };
  return {
    get: async (n, i) => await r("get", n, i),
    head: async (n, i) => r("head", n, i),
    post: async (n, i) => a("post", n, i),
    put: async (n, i) => a("put", n, i),
    patch: async (n, i) => a("patch", n, i),
    delete: async (n, i) => a("delete", n, i)
  };
};
export {
  T as FetcherBusinessRuleError,
  x as FetcherConnectionLostError,
  R as FetcherFormValidationError,
  w as FetcherHTTPError,
  _ as FetcherNotFoundError,
  k as FetcherTooManyRequestsError,
  S as FetcherUnauthorizedError,
  E as FetcherUnknownError,
  be as fetcher,
  de as isFetcherBusinessRuleError,
  pe as isFetcherConnectionLostError,
  le as isFetcherFormValidationError,
  ue as isFetcherHTTPError,
  me as isFetcherNotFoundError,
  ge as isFetcherTooManyRequestsError,
  ye as isFetcherUnauthorizedError,
  fe as isFetcherUnknownError
};
